import {createListResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const ProductListItemSchema = z.object({
  id: z.string(),
  productName: z.string().nullable(),
  status: z.number(),
  categoryName: z.string().nullable(),
  price: z.number(),
  skuID: z.string().nullable(),
  barcode: z.string().nullable(),
  subCategoryName: z.string().nullable(),
  approvedProduct: z.boolean().nullable(),
  payWithPoints: z.boolean().nullable(),
  eligibleForPoints: z.boolean().nullable(),
  eligibleForDiscount: z.boolean().nullable(),
})

export const ProductListSchemaResponse = createListResponseSchema(ProductListItemSchema.array())

export type ProductListItem = z.infer<typeof ProductListItemSchema>
export type ProductList = z.infer<typeof ProductListSchemaResponse.shape.response>
export type ProductListResponse = z.infer<typeof ProductListSchemaResponse>

const filterListSchema = z.array(
  z.object({
    operator: z.number(),
    key: z.string(),
    value: z.array(z.string()),
    logicalOp: z.number().optional(),
    childFilters: z.array(z.object({})).optional(),
  })
)

const orderListSchema = z.array(
  z.object({
    type: z.number(),
    key: z.string(),
  })
)

const pagingSchema = z.object({
  currentPageNumber: z.number(),
  pageSize: z.number(),
})

const searchSchema = z.object({
  value: z.string(),
  keyList: z.array(z.string()),
})

export const listFilterSchema = z.object({
  filterList: filterListSchema,
  orderList: orderListSchema,
  paging: pagingSchema,
  // search: searchSchema
})

export type ListFilter = z.infer<typeof listFilterSchema>
